const receivingType = {
	transfer: 'transfer',
	container: 'container',
};

export { receivingType };



// WEBPACK FOOTER //
// ./src/common/constants/receivingTypeConstants.js